import {graphql} from 'gatsby'
import React, {useEffect, useState} from 'react'
import ColumnBackAndForth from '../../../components/atoms/columnBackAndForth'
import SEO from '../../../components/atoms/seo'
import {ITopicPath} from '../../../components/atoms/topicPath'
import ColumnAuthor001 from '../../../components/molecules/columnAuthor001'
import ColumnDetailInner0006 from '../../../components/molecules/columnDetailInner0006'
import ColumnRelationCards0006 from '../../../components/molecules/columnRelationCards0006'
import ColumnDetailsBody from '../../../components/organisms/columnDetailsBody'
import ColumnLayout from '../../../components/organisms/columnLayout'
import Conclusion001 from '../../../components/molecules/Conclusion001'
import Conclusion004 from '../../../components/molecules/Conclusion004'
import Conclusion007 from '../../../components/molecules/Conclusion007'
import Conclusion002 from '../../../components/molecules/Conclusion002'
import Conclusion005 from '../../../components/molecules/Conclusion005'
import Conclusion008 from '../../../components/molecules/Conclusion008'
import Conclusion003 from '../../../components/molecules/Conclusion003'
import Conclusion006 from '../../../components/molecules/Conclusion006'
import Conclusion009 from '../../../components/molecules/Conclusion009'
import PopupBanner from '../../../components/molecules/popupBanner'
import CarouselBanner from '../../../components/molecules/carouselBanner'
import useRouteParam from '../../../hooks/useRouteParam'
import UsefulFunctionLayout021 from '../../../components/molecules/usefulFunctionLayout021'

/**
 * コラム記事詳細画面
 * @constructor
 */
const C0006 = () => {
  const paths: ITopicPath[] = [
    { title: 'キンクラコラムTOP', link: useRouteParam('/column') },
    { title: 'コラム記事一覧', link: useRouteParam('/column/list') },
    {
      title: '通常の労働時間制（固定労働時間制度）と変形労働時間制について',
    },
  ]
  // 0~8ランダム数字を保存
  const [no, setNo] = useState(-1)
  useEffect(() => {
    setNo(Math.floor(Math.random() * 9))
  }, [])

  return (
    <ColumnLayout paths={paths}>
      <SEO
        title="通常の労働時間制（固定労働時間制度）と変形労働時間制とは？"
        description="通常の労働時間制、フレックスタイム制、裁量労働制など、働き方の多様化に対応した労働時間制があります。どの制度を活用するのがベストなのか、おさえておく点を解説。"
        ogUrl="https://kintaicloud.jp/column/details/C0006/"
        ogType="article"
        ogTitle="通常の労働時間制（固定労働時間制度）と変形労働時間制とは？"
        ogDescription="通常の労働時間制、フレックスタイム制、裁量労働制など、働き方の多様化に対応した労働時間制があります。どの制度を活用するのがベストなのか、おさえておく点を解説。"
        ogSiteName="キンクラ - 客先常駐特化型のクラウド勤怠管理システム"
        ogImage="https://www.kintaicloud.jp/images/column/details/c0006.jpg"
      />
      <ColumnDetailsBody>
        {/** ポップアップバナー */}
        <PopupBanner />
        {/** 記事本体 */}
        <ColumnDetailInner0006 no={no} />
        {/** オーサ情報 */}
        <ColumnAuthor001 />
        {/** ここに9パターンの広告設定する */}
        {no === 0 && <Conclusion001 />}
        {no === 1 && <Conclusion002 />}
        {no === 2 && <Conclusion003 />}
        {no === 3 && <Conclusion004 />}
        {no === 4 && <Conclusion005 />}
        {no === 5 && <Conclusion006 />}
        {no === 6 && <Conclusion007 />}
        {no === 7 && <Conclusion008 />}
        {no === 8 && <Conclusion009 />}
        {/** お役立ち機能 */}
        <UsefulFunctionLayout021 />
        {/** 前後記事への遷移 */}
        <ColumnBackAndForth />
        {/** カルーセルバナー */}
        <CarouselBanner />
        {/** 関連記事 */}
        <ColumnRelationCards0006 />
      </ColumnDetailsBody>
    </ColumnLayout>
  )
}

export default C0006

export const pageQuery = graphql`
  query C0006 {
    site {
      siteMetadata {
        title
      }
    }
  }
`
